import { MultiTenantCapabilitiesCustomerTypes } from '@explorer/forms/types';

const allMtcCustomerTypes = [
  MultiTenantCapabilitiesCustomerTypes.CHANNEL_PARTNER,
  MultiTenantCapabilitiesCustomerTypes.DEMO,
  MultiTenantCapabilitiesCustomerTypes.MSP_TRIAL,
  MultiTenantCapabilitiesCustomerTypes.MULTI_TENANT_MSP,
  MultiTenantCapabilitiesCustomerTypes.MULTI_TENANT_PE,
  MultiTenantCapabilitiesCustomerTypes.MULTI_TENANT_PH,
  MultiTenantCapabilitiesCustomerTypes.OTHER,
] as const;

export const MTC_CUSTOMER_TYPES_MAP: Record<
  MultiTenantCapabilitiesCustomerTypes,
  string
> = {
  [MultiTenantCapabilitiesCustomerTypes.CHANNEL_PARTNER]:
    'forms-presets.mtc.channel-partner',
  [MultiTenantCapabilitiesCustomerTypes.DEMO]: 'forms-presets.mtc.demo',
  [MultiTenantCapabilitiesCustomerTypes.MSP_TRIAL]:
    'forms-presets.mtc.msp-trial',
  [MultiTenantCapabilitiesCustomerTypes.MULTI_TENANT_MSP]:
    'forms-presets.mtc.multi-tenant-msp',
  [MultiTenantCapabilitiesCustomerTypes.MULTI_TENANT_PE]:
    'forms-presets.mtc.multi-tenant-pe',
  [MultiTenantCapabilitiesCustomerTypes.MULTI_TENANT_PH]:
    'forms-presets.mtc.multi-tenant-ph',
  [MultiTenantCapabilitiesCustomerTypes.OTHER]: 'forms-presets.mtc.other',
};

const defaultMtcCustomerTypeOption = {
  label: {
    id: MTC_CUSTOMER_TYPES_MAP[
      MultiTenantCapabilitiesCustomerTypes.MULTI_TENANT_MSP
    ],
  },
  value: MultiTenantCapabilitiesCustomerTypes.MULTI_TENANT_MSP,
};

const mtcCustomerTypesOptions = allMtcCustomerTypes.map((customerType) => ({
  label: { id: MTC_CUSTOMER_TYPES_MAP[customerType] },
  value: customerType,
}));

export { mtcCustomerTypesOptions, defaultMtcCustomerTypeOption };
